/* eslint-disable no-undef */
import axios from 'axios';
import getAuthBaseUrl from './authBaseUrl';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import { getParsedPermissions } from 'Utils/permissionsUtils';
import {
  getPaperlessFlow,
  setPaperlessRedirectionToReporting,
} from '../../../dims-common-ui/components/utils_paperless_flow/PaperlessCommon';
import { VITE_AUTH_HEADER_PREFIX, VITE_GP_VERSION, VITE_MERCHANT_APPLICATION_URL } from 'Constants/appEnvConstants';

const baseUrl = getAuthBaseUrl();

/**
 * Calls Autgh service to che ck whether id token received from azure is valid or not.
 * @param  {string} accessToken  a JSON web token
 * @return {Promise}          an Axios request
 */
export function validateAuthToken(accessToken) {
  axios.defaults.headers.common.Authorization = VITE_AUTH_HEADER_PREFIX + accessToken;
  axios.defaults.headers.common['x-gp-version'] = VITE_GP_VERSION;
  return post('api/v1/auth/users/token/validate', null);
}
export function getAuthenticatedUser(accessToken, dataAccessRequired) {
  axios.defaults.headers.common.Authorization = VITE_AUTH_HEADER_PREFIX + accessToken;
  axios.defaults.headers.common['x-gp-version'] = VITE_GP_VERSION;
  
  const urlIdentifier = sessionStorage.getItem('appPortal');
  return get(`api/v1/auth/user/data/authorization?dataAccessRequired=${dataAccessRequired}&urlIdentifier=${urlIdentifier}`)
    .then((response) => {
      console.warn('getting response from auth call');
      localStorage.setItem('activeCases', JSON.stringify([]));
      response.data.parsedPermissions = getParsedPermissions(response.data.role.permissions);
      return response;
    })
    .catch((error) => {
      console.warn('in auth API catch block', error);
      throw error.response.status;
    });
}

export function redirectToReportingPortalForRegistration() {
  const port = window.location.port ? `:${window.location.port}` : '';
  let redirectUri = `https://${window.location.hostname}${port}`;
  const messageIdentifier = 'basepath.disputePaperless';
  console.warn('redirectToReportingPortalForRegistration');
  if (getPaperlessFlow()) {
    console.warn('setting paperless redirection to reporting');
    setPaperlessRedirectionToReporting();
  }

  console.warn('Redirecting to Reporting portal');
  location.assign(`${VITE_MERCHANT_APPLICATION_URL}?redirectUrl=${redirectUri}&messageIdentifier=${messageIdentifier}`);
}

export function logoutFromCache() {
  configureHttpHeaders(axios);
  return post('api/v1/auth/user/logout', null);
}
function get(url) {
  /* eslint-enable dot-notation */
  return axios.get(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}
function post(url, body) {
  return axios.post(`${baseUrl}${url}`, body).then(onSuccess).catch(onError);
}

export default {
  validateAuthToken,
  logoutFromCache,
};
